var _path, _path2, _path3, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPenaltyOnDeposit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.49537 12.25V3.75C2.49537 2.02409 3.89177 0.625 5.61428 0.625H3.74293C2.02042 0.625 0.624023 2.02409 0.624023 3.75V12.25C0.624023 13.9759 2.02042 15.375 3.74293 15.375H5.61428C3.89177 15.375 2.49537 13.9759 2.49537 12.25Z",
    fill: "#EBEBF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79727 16H3.74269C1.67897 16 0 14.3177 0 12.25V3.75C0 1.68225 1.67897 0 3.74269 0H12.2261C14.2898 0 15.9688 1.68225 15.9688 3.75V5.21875C15.9359 6.048 14.7539 6.04738 14.7212 5.21875V3.75C14.7212 2.3715 13.6019 1.25 12.2261 1.25H3.74269C2.36688 1.25 1.24756 2.3715 1.24756 3.75V12.25C1.24756 13.6285 2.36688 14.75 3.74269 14.75H4.79727C5.6249 14.783 5.62428 15.9673 4.79727 16ZM10.1988 3.4375C10.1988 3.09231 9.91956 2.8125 9.57505 2.8125H6.39376C5.56613 2.8455 5.56675 4.02978 6.39376 4.0625H9.57505C9.91956 4.0625 10.1988 3.78269 10.1988 3.4375Z",
    fill: "#303261"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6333 8.99516C11.0361 8.33495 11.9639 8.33495 12.3667 8.99516L15.3385 13.8666C15.7823 14.5941 15.2583 15.5 14.4718 15.5H8.52816C7.74168 15.5 7.21768 14.5941 7.66146 13.8666L10.6333 8.99516Z",
    stroke: "#F16D5C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.75,
    y: 13,
    width: 1.5,
    height: 1.5,
    rx: 0.75,
    fill: "#F16D5C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.75,
    y: 10,
    width: 1.5,
    height: 2.5,
    rx: 0.75,
    fill: "#F16D5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenaltyOnDeposit);
export default __webpack_public_path__ + "static/media/penalty_on_deposit.e88da7988edf8fd3b329530e9b7882f6.svg";
export { ForwardRef as ReactComponent };